import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { HierarchiesField } from '@/utils/enum';
import { useGetCellules } from '@/hooks/useGetCellules';
import { SelectWithCreation } from '@/components/ui/Inputs';
import { hierarchyHandler } from '@/utils/hierarchy-handler';
import * as S from './styles';

const { useFormInstance, useWatch } = Form;

export function Cellules(): JSX.Element {
	const form = useFormInstance();
	const sectorId = useWatch(HierarchiesField.SECTOR, form);
	const companyId = useWatch(HierarchiesField.COMPANY, form);
	const organizationId = useWatch(HierarchiesField.ORGANIZATION, form);

	const title = I18n.get('Cell');
	const fieldName = HierarchiesField.CELLULE;

	const {
		isFetching: isGettingCellules,
		data: cellules,
		isError: errorGettingCellules
	} = useGetCellules({
		organization_id: organizationId,
		company_id: companyId,
		sector_id: sectorId
	});

	function handleOnChange(id: string): void {
		const fieldsToReset = hierarchyHandler.getHierarchiesFieldsToClear(fieldName);
		if (fieldsToReset && id) {
			form.resetFields(fieldsToReset);
			form.setFieldValue(fieldName, id);
		}
	}

	function handleOnClear(): void {
		const fieldsToReset = hierarchyHandler.getHierarchiesFieldsToClear(fieldName);
		fieldsToReset && form.resetFields(fieldsToReset);
	}

	const isDisabled = !sectorId || !cellules || errorGettingCellules;

	return (
		<Form.Item name={fieldName} label={<S.Label>{title}</S.Label>}>
			<SelectWithCreation
				showSearch
				allowClear
				placeholder={title}
				disabled={isDisabled}
				selectOptions={cellules}
				loading={isGettingCellules}
				onClear={handleOnClear}
				onChange={handleOnChange}
			/>
		</Form.Item>
	);
}
